
export const delItem = (key) => localStorage.removeItem(key)
export const getItem = (key) => localStorage.getItem(key)
export const setItem = (key, item) => localStorage.setItem(key, item)
export const useLocalStorage = () => ({ delItem, getItem, setItem, })